import { useState } from "react";

const faqs = [
  {
    q: "How do I get an expedited passport in Coeur d'Alene, Idaho?",
    a: "Coeur d'Alene residents can use Fast Passport Center for 2–9 day expedited processing. Ship your documents overnight and we handle agency submission remotely. The nearest regional agency is in Seattle, over 300 miles west across the Cascades.",
  },
  {
    q: "Where is the nearest passport agency to Coeur d'Alene?",
    a: "The Seattle Regional Passport Agency (300 5th Ave, Seattle, WA) is approximately 300 miles west of Coeur d'Alene. It requires an appointment for emergencies only. Fast Passport Center eliminates that trip entirely.",
  },
  {
    q: "What passport acceptance facilities are available in Coeur d'Alene?",
    a: "CDA has several facilities including the Main Post Office on N 7th St, the Kootenai County Clerk's Office on N Government Way, and post offices in Post Falls, Hayden, and Sandpoint. New applicants and minors must visit one of these in person.",
  },
  {
    q: "Can I renew my passport by mail from Coeur d'Alene?",
    a: "Yes. If you are 16 or older, your passport is less than 15 years old, and it was issued after age 16, you can renew entirely by mail using DS-82. Fast Passport Center handles the whole process — no post office visit needed.",
  },
  {
    q: "How long does a passport take from Coeur d'Alene?",
    a: "Through Fast Passport Center: 2–9 business days for expedited, 24 hours for life-or-death emergency. Routine post office processing takes 6–11 weeks. Standard post office expedited takes 3–5 weeks.",
  },
  {
    q: "What airport should I fly out of from Coeur d'Alene?",
    a: "Spokane International Airport (GEG) is 30 miles west and is the nearest major airport for Coeur d'Alene travelers. It offers nonstop service to Seattle, Los Angeles, Denver, and other domestic hubs for international connections.",
  },
  {
    q: "What if I'm applying for my child's passport near Coeur d'Alene?",
    a: "Children under 16 require both parents to appear at the acceptance facility, or a parent must provide notarized DS-3053 consent. We guide northern Idaho families through every parental consent requirement including the Kootenai County Clerk option.",
  },
  {
    q: "Can I use my Coeur d'Alene address for passport delivery?",
    a: "Yes. Your new passport will be mailed directly to any U.S. address you provide, including your Coeur d'Alene home or office. Most expedited passports arrive within 1–2 business days of processing completion.",
  },
];

export default function FAQSection() {
  const [open, setOpen] = useState<number | null>(null);

  return (
    <section id="faq" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">FAQ</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Passport Questions from Coeur d&apos;Alene Travelers
          </h2>
          <p className="text-gray-500 max-w-xl mx-auto text-base leading-relaxed">
            Answers to the most common passport questions from Coeur d&apos;Alene, Post Falls, Hayden, Sandpoint, and all of Kootenai County.
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div key={i} className="bg-white border border-gray-200 rounded-lg overflow-hidden">
              <button
                onClick={() => setOpen(open === i ? null : i)}
                className="w-full flex items-center justify-between p-5 text-left"
              >
                <span className="font-semibold text-[#1A365D] text-sm pr-4">{faq.q}</span>
                <i className={`flex-shrink-0 text-[#1A365D] transition-transform ${open === i ? "ri-subtract-line" : "ri-add-line"}`}></i>
              </button>
              {open === i && (
                <div className="px-5 pb-5">
                  <p className="text-gray-600 text-sm leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "FAQPage",
              mainEntity: faqs.map((f) => ({
                "@type": "Question",
                name: f.q,
                acceptedAnswer: { "@type": "Answer", text: f.a },
              })),
            }),
          }}
        />
      </div>
    </section>
  );
}